var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Card"
  }, [_c('div', {
    staticClass: "Card-content w-100"
  }, [_vm.title !== '' ? _c('h1', {
    staticClass: "Card-title",
    attrs: {
      "aria-label": _vm.title,
      "tabindex": _vm.globalTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }